import React, { ReactNode, useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import * as Sentry from '@sentry/browser';
import posthog from 'posthog-js';

import ThemeConfig from '@core/theme/index';
import { skinInit } from '@store/skin';

interface IProps {
  children: ReactNode,
}
interface IState {}

const AppTheme = (props: IProps, state: IState) => {
  const { children } = props;

  useEffect(() => {
    Sentry.init({
      dsn: 'https://e141c7e4b2c24d6b8a7fb2f05b6c34cd@sentry.smartsalary.club/12',
      // integrations: [new Integrations.BrowserTracing()],
      // tracesSampleRate: 1.0,
    });

    skinInit();
  }, []);

  return (
    <ThemeProvider theme={ThemeConfig}>{ children }</ThemeProvider>
  );
};

export default AppTheme;
